import React, { Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { FallbackErrorPage } from '@prometheus/features';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RouterErrorBoundary } from './components/RouterErrorBoundary';
import { Providers } from './Providers';

const Start = (nameSelector: string, store: any) => {
  const container = document.getElementById(nameSelector);
  const root = createRoot(container!);
  const router = createBrowserRouter([
    {
      path: '*',
      element: (
        <ErrorBoundary
          fallback={
            <FallbackErrorPage
              status={42}
              statusText="Answer to the Ultimate Question of Life, The Universe, and Everything"
            />
          }
        >
          <Providers>
            <App />
          </Providers>
        </ErrorBoundary>
      ),
      ErrorBoundary: RouterErrorBoundary,
    },
  ]);

  root.render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

export default Start;
